import React from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import TwitterIcon from "@mui/icons-material/Twitter";
import SvgIcon from "@mui/material/SvgIcon";

import {setGroheShareButtonsOpened} from "../../../../actions/groheFunctions";
import {LookShareIcons} from "../../../common/icons";
import {setLookOverlayOpened, setLookReturnAction} from "../../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../../core/constants";
import {saveQuoteAndShare} from "../../lookNavigation/lookFunctions2";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {pricingIsLocked} from "../../lookNavigation/lookNavigationFunctions";

const GroheShareButton = (props) => {

  const {intl, buttonKey, setGroheShareButtonsOpened, propsShareUrl, userIsLoggedIn, setLookOverlayOpened, setLookReturnAction} = props;

  const shareButtonClick = (buttonKey) => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productTopButtonsShare + buttonKey);
    setGroheShareButtonsOpened(false);

    if (!userIsLoggedIn) {
      const {isLixil} = pricingIsLocked();
      if (isLixil) {
        setLookOverlayOpened(LOOK_OVERLAYS.questionShare);
        setLookReturnAction(buttonKey);
      } else {
        setLookOverlayOpened(LOOK_OVERLAYS.leadCapture, buttonKey);
      }
      return false;
    }

    saveQuoteAndShare(buttonKey, propsShareUrl);
  }

  return (
    <div className={"gm-share__button gm-share__button--" + buttonKey}>
      <IconButton aria-label={intl.formatMessage({id: "iconButton.share"})}
                  className="look-icon look-icon--small1 look-icon--grohe"
                  onClick={() => shareButtonClick(buttonKey)}>
        {(buttonKey === "twitter") ? <TwitterIcon/> : <SvgIcon>{LookShareIcons[buttonKey]}</SvgIcon>}
      </IconButton>
    </div>
  )
};

GroheShareButton.propTypes = {
  buttonKey: PropTypes.string.isRequired
}

const mapStateToProps = (store) => {
  const {userIsLoggedIn} = store.userState;
  const {shareUrl} = store.serverState;
  return {
    userIsLoggedIn,
    propsShareUrl: shareUrl,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setGroheShareButtonsOpened,
  setLookReturnAction,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GroheShareButton)
  )
)
